/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import "./css/Emergencies.css";
import {
  getAllEmergenciesByAdmin,
  resolveEmergencyByAdmin,
} from "../api/emergenyApi";
import { socket } from "../socket";
import AccessControl from "../components/AccessControl";
import Loader from "../components/Loader";
// import { getAllEmergenciesByAdmin, resolveEmergencyByAdmin } from "../api/emergencyApi";

const REASON_EMOJI = {
  Accident: "💥",
  "Driver misbehaviour": "⚠️",
  "Medical emergency": "🏥",
  "Robbery / Theft": "🦹",
  "Vehicle breakdown": "🛺",
  "Unsafe driving": "🚦",
  Other: "❗",
};

const STATUS_COLORS = {
  active: { bg: "#fff1f0", text: "#cf1322", border: "#ffa39e" },
  resolved: { bg: "#f6ffed", text: "#389e0d", border: "#b7eb8f" },
};

export default function Emergencies() {
  const [emergencies, setEmergencies] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [resolving, setResolving] = useState(null);
  const [resolveModal, setResolveModal] = useState(null);
  const [resolveNote, setResolveNote] = useState("");

  const limit = 10;
  const totalPages = Math.ceil(total / limit);

  // ─── Fetch ───────────────────────────────────
  const fetchEmergencies = useCallback(async () => {
    setLoading(true);

    const res = await getAllEmergenciesByAdmin({
      n_limit: limit,
      n_page: page,
      c_search_term: search,
    });

    if (res.success) {
      let data = res.emergencies || [];
      if (statusFilter !== "all") {
        data = data.filter((e) => e.status === statusFilter);
      }
      setEmergencies(data);
      setTotal(res.total || 0);
    } else {
      console.log(res, "<<< emergency fetch error");
      // toast.error(res.message );
    }

    setLoading(false);
  }, [page, search, statusFilter]);

  // ─── Search ───────────────────────────────────
  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchInput);
    setPage(1);
  };

  // ─── Resolve ──────────────────────────────────
  const openResolve = (emergency) => {
    setResolveModal(emergency);
    setResolveNote("");
  };

  const confirmResolve = async () => {
    if (!resolveModal) return;
    setResolving(resolveModal._id);

    const admin = localStorage.getItem("admin");
    const adminData = admin ? JSON.parse(admin) : null;
    const resolvedBy = adminData?.name || adminData?.email || "Admin";

    // ✅ existing call — அப்படியே maintain
    const res = await resolveEmergencyByAdmin(resolveModal._id, {
      resolvedBy,
      resolvedNote: resolveNote,
    });

    if (res.success) {
      toast.success("✅ Emergency resolved successfully");
      setResolveModal(null);
      setResolveNote("");
      fetchEmergencies();
    } else {
      toast.error(res.error || "Failed to resolve");
    }

    setResolving(null);
  };
  useEffect(() => {
    fetchEmergencies();
  }, [fetchEmergencies]);

  useEffect(() => {
    const handleSOS = () => {
      console.log("🚨 SOS received — refreshing emergencies...");
      fetchEmergencies();
    };

    socket.on("sos-alert", handleSOS);

    return () => {
      socket.off("sos-alert", handleSOS);
    };
  }, [fetchEmergencies]); // fetchEmergencies is stable (useCallback)

  // ─── Render ───────────────────────────────────
  return (
    <div className="emg-page">
     <AccessControl
             allowedRoles={["SUPERADMIN", "ADMIN","HR", "NSM", "RSM", "ASM", "TSO"]}
             redirectTo="/404"
           />
      {/* Header */}
      <div className="emg-header">
        <div className="emg-title">
          <span className="emg-title-icon">🚨</span>
          <div>
            <h1>Emergency Management</h1>
            <p>{total} total alerts</p>
          </div>
        </div>

        {/* Status filter tabs */}
        <div className="emg-tabs">
          {["all", "active", "resolved"].map((s) => (
            <button
              key={s}
              className={`emg-tab ${statusFilter === s ? "active" : ""} emg-tab--${s}`}
              onClick={() => {
                setStatusFilter(s);
                setPage(1);
              }}
            >
              {s === "all"
                ? "All"
                : s === "active"
                  ? "🔴 Active"
                  : "✅ Resolved"}
            </button>
          ))}
        </div>
      </div>

      {/* Search */}
      <form className="emg-search-bar" onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="Search by name, mobile, reason..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="emg-search-input"
        />
        <button type="submit" className="emg-search-btn">
          Search
        </button>
        {search && (
          <button
            type="button"
            className="emg-clear-btn"
            onClick={() => {
              setSearch("");
              setSearchInput("");
              setPage(1);
            }}
          >
            ✕ Clear
          </button>
        )}
      </form>

      {/* Table */}
      {loading ? (
        <Loader />
      ) : emergencies.length === 0 ? (
        <div className="emg-empty">
          <span>🎉</span>
          <p>No emergencies found</p>
        </div>
      ) : (
        <div className="emg-table-wrap">
          <table className="emg-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Passenger</th>
                <th>Reason</th>
                <th>Location</th>
                <th>Time</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {emergencies.map((e, i) => {
                const sc = STATUS_COLORS[e.status] || STATUS_COLORS.active;
                return (
                  <tr key={e._id} className="emg-row">
                    <td className="emg-num">{(page - 1) * limit + i + 1}</td>

                    {/* Passenger */}
                    <td>
                      <div className="emg-passenger">
                        <span className="emg-pname">{e.passengerName}</span>
                        <span className="emg-pmobile">{e.passengerMobile}</span>
                      </div>
                    </td>

                    {/* Reason */}
                    <td>
                      {e.reason ? (
                        <div className="emg-reason-cell">
                          <span className="emg-reason-badge">
                            {REASON_EMOJI[e.reason] || "❗"} {e.reason}
                          </span>
                          {e.reasonNote && (
                            <span className="emg-reason-note">
                              "{e.reasonNote}"
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="emg-na">—</span>
                      )}
                    </td>

                    {/* Location */}
                    <td>
                      <a
                        className="emg-location-link"
                        href={`https://maps.google.com/?q=${e.location?.lat},${e.location?.lng}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        📍 View Map
                      </a>
                      <div className="emg-coords">
                        {e.location?.lat?.toFixed(4)},{" "}
                        {e.location?.lng?.toFixed(4)}
                      </div>
                    </td>

                    {/* Time */}
                    <td className="emg-time">
                      {new Date(e.createdAt).toLocaleDateString()}
                      <br />
                      <span>{new Date(e.createdAt).toLocaleTimeString()}</span>
                    </td>

                    {/* Status */}
                    <td>
                      <span
                        className="emg-status-badge"
                        style={{
                          background: sc.bg,
                          color: sc.text,
                          border: `1px solid ${sc.border}`,
                        }}
                      >
                        {e.status === "active" ? "🔴 Active" : "✅ Resolved"}
                      </span>
                      {e.status === "resolved" && e.resolvedBy && (
                        <div className="emg-resolved-by">by {e.resolvedBy}</div>
                      )}
                    </td>

                    {/* Action */}
                    <td>
                      {e.status === "active" ? (
                        <button
                          className="emg-resolve-btn"
                          onClick={() => openResolve(e)}
                          disabled={resolving === e._id}
                        >
                          {resolving === e._id ? "Resolving..." : "✓ Resolve"}
                        </button>
                      ) : (
                        <span className="emg-done-text">Done</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="emg-pagination">
          <button
            className="emg-page-btn"
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            ← Prev
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter(
              (p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1,
            )
            .reduce((acc, p, idx, arr) => {
              if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
              acc.push(p);
              return acc;
            }, [])
            .map((p, i) =>
              p === "..." ? (
                <span key={`dots-${i}`} className="emg-dots">
                  …
                </span>
              ) : (
                <button
                  key={p}
                  className={`emg-page-btn ${page === p ? "active" : ""}`}
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              ),
            )}
          <button
            className="emg-page-btn"
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next →
          </button>
        </div>
      )}

      {/* ─── Resolve Modal ─── */}
      {resolveModal && (
        <div
          className="emg-modal-overlay"
          onClick={() => setResolveModal(null)}
        >
          <div className="emg-modal" onClick={(ev) => ev.stopPropagation()}>
            <div className="emg-modal-header">
              <h2>✅ Resolve Emergency</h2>
              <button
                className="emg-modal-close"
                onClick={() => setResolveModal(null)}
              >
                ✕
              </button>
            </div>

            {/* Summary */}
            <div className="emg-modal-summary">
              <div className="emg-modal-row">
                <span>👤 Passenger</span>
                <strong>{resolveModal.passengerName}</strong>
              </div>
              <div className="emg-modal-row">
                <span>📞 Mobile</span>
                <strong>{resolveModal.passengerMobile}</strong>
              </div>
              {resolveModal.reason && (
                <div className="emg-modal-row">
                  <span>⚡ Reason</span>
                  <strong>
                    {REASON_EMOJI[resolveModal.reason]} {resolveModal.reason}
                    {resolveModal.reasonNote
                      ? ` — "${resolveModal.reasonNote}"`
                      : ""}
                  </strong>
                </div>
              )}
              <div className="emg-modal-row">
                <span>📍 Location</span>
                <a
                  href={`https://maps.google.com/?q=${resolveModal.location?.lat},${resolveModal.location?.lng}`}
                  target="_blank"
                  rel="noreferrer"
                  className="emg-location-link"
                >
                  View on Map ↗
                </a>
              </div>
            </div>

            {/* Admin resolve note */}
            <div className="emg-modal-note-section">
              <label>
                Resolution Note <span>(optional)</span>
              </label>
              <textarea
                className="emg-modal-textarea"
                placeholder="e.g. Police dispatched, passenger safe, false alarm..."
                value={resolveNote}
                onChange={(e) => setResolveNote(e.target.value)}
                rows={3}
              />
            </div>

            <div className="emg-modal-actions">
              <button
                className="emg-modal-cancel"
                onClick={() => setResolveModal(null)}
              >
                Cancel
              </button>
              <button
                className="emg-modal-confirm"
                onClick={confirmResolve}
                disabled={resolving === resolveModal._id}
              >
                {resolving === resolveModal._id
                  ? "Resolving..."
                  : "✓ Confirm Resolve"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
